/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/sum.json`.

import type { FunctionDefinition } from '../../definition_types';

/**
 * The sum of a numeric expression.
 *
 * @example
 * FROM employees
 * | STATS SUM(languages)
 *
 * @example
 * FROM employees
 * | STATS total_salary_changes = SUM(MV_MAX(salary_change))
 *
 * @example
 * TS exp_histo_sample
 * | WHERE instance == "instance-0"
 * | STATS total = ROUND(SUM(responseTime), 2)
 *
 * @example
 * TS histogram_timeseries_index
 * | WHERE instance == "instance-0"
 * | STATS total = ROUND(SUM(responseTime::tdigest), 2)
 */
const definition: FunctionDefinition = {
  type: 'agg',
  name: 'sum',
  signatures: [
    {
      params: [
        {
          name: 'number',
          type: 'aggregate_metric_double',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
    {
      params: [
        {
          name: 'number',
          type: 'dense_vector',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'dense_vector',
    },
    {
      params: [
        {
          name: 'number',
          type: 'double',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
    {
      params: [
        {
          name: 'number',
          type: 'exponential_histogram',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
    {
      params: [
        {
          name: 'number',
          type: 'integer',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'long',
    },
    {
      params: [
        {
          name: 'number',
          type: 'long',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'long',
    },
    {
      params: [
        {
          name: 'number',
          type: 'tdigest',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
  ],
  preview: false,
  snapshotOnly: false,
};

export default definition;
